import { Component, OnInit } from '@angular/core';

import { SideMenuItem } from '../admin-side-menu/admin-side-menu.component';
import { GlobalMethods } from '../../../../app/common/global-methods';

@Component({
  selector: 'app-admin-profile',
  templateUrl: './admin-profile.component.html',
  styleUrls: ['./admin-profile.component.scss', '../../../../css/2-modules/_admin-portal.scss']
})
export class AdminProfileComponent implements OnInit {

  loading: boolean = false;
  isSideMenuVisible: boolean = true;

  menuType: string = 'profile';
  currentHeading: string | undefined | null = null;
  currentDescription: string | undefined | null = null;

  constructor() { }

  ngOnInit(): void {
    GlobalMethods.scrollToTop();
  }

  toggleSideMenu(): void {
    this.isSideMenuVisible = !this.isSideMenuVisible;
  }

  onSideMenuChange(selectedItem: SideMenuItem): void {
    this.currentHeading = selectedItem.value;
    this.currentDescription = selectedItem.description;
    GlobalMethods.scrollToTop();
  }
}
